import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.aufgabe-bemerkung-setzen';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksAufgabeBemerkungSetzenEffects {

    AufgabeBemerkungSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_AUFGABE_BEMERKUNG_SETZEN),
        mergeMap((x: ac.PostAufgabeBemerkungSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postAufgabeBemerkungSetzen(x.prueflaufAufgabeBemerkungRequest).pipe(
                map((result: any) => {
                    return new ac.PostAufgabeBemerkungSetzenErfolgreichAction(result, x.prueflaufAufgabeBemerkungRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostAufgabeBemerkungSetzenFehlerAction(error, x.prueflaufAufgabeBemerkungRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.PrueflaufCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.PrueflaufCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.PrueflaufCommandService);
        }
        return this.service;
    }
}
